import { useState } from "react";
import { getMenuLateralByIdData } from "../api/menu";
import { PrincipalSidebarDto } from "../models/Sidebar.model";

export const useSidebar = () => {
    const [isShowMenu, setIsShowMenu] = useState(false);
    const [menuPrincipal, setMenuPrincipal] = useState<PrincipalSidebarDto[]>([]);
    const [menuOpen, setMenuOpen] = useState<string | null>(null);
    const [menuData, setMenuData] = useState<{ [key: string]: PrincipalSidebarDto[] }>({});

    const getMenuById = async (id: string) => {
        try {
            const data = await getMenuLateralByIdData(id);
            setMenuPrincipal(data);
        } catch (err) {
            console.log(err);
        }
    };

    const handleShowMenu = (show: boolean) => {
        setIsShowMenu(show)
    }

    const handleMenuClick = async (id: string, titulo: string) => {
        if (!menuData[titulo]) {
            try {
                const data = await getMenuLateralByIdData(id);
                setMenuData(prevData => ({
                    ...prevData,
                    [titulo]: data
                }));
            } catch (err) {
                console.log(err);
            }
        }
        setMenuOpen(titulo)
    };

    return {
        getMenuById,
        menuPrincipal,
        isShowMenu,
        handleShowMenu,
        handleMenuClick,
        menuOpen,
        menuData
    }
}
